<template>
  <v-app>
    <v-main class="pt-4">
      <v-row justify="center">
        <v-dialog
          v-model="dialog"
          max-width="600">
          <v-card>
            <v-card-title class="headline">{{head_info}}</v-card-title>
            <v-card-text>
              {{info}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="dialog = false, info = '', redirectLogin(resultRegistration)">
                Хорошо
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-card
        class="mx-auto"
        max-width="700"
        style="padding:30px; padding-top: 0px; margin:30px; z-index:1;">
        <v-card-text>
          <div>Регистрация</div>
          <v-row>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="lastName"
                :label="surNameLabel"
                placeholder="Фамилия"
                :error-messages="lastNameValidate"
                :error="lastName_error"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="name"
                 placeholder="Имя"
                :label="nameLabel"
                required
                :error-messages="nameValidate"
                :error="name_error"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-text-field
                v-model="middleName"
                 placeholder="Отчество"
                :label="patronymicLabel"
                required
                :error-messages="middleNameValidate"
                :error="middleName_error"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="6">
              <v-autocomplete
                v-model="valueOrganization"
                :items="organizations"
                item-value="id"
                item-text="name"
                :label='scienceOrganizationLabel'
                prepend-icon="mdi-city"
                :error="valueOrganization_error"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row style="margin-top: -20px">
            <v-col class="pt-3" cols="12" lg="4">
              <v-checkbox
                class="mt-0"
                :color="$mainColor"
                v-model="checkbox_other_org"
                label="другая"
              ></v-checkbox>
            </v-col>
            <v-col class="pt-0" cols="12" lg="8">
              <v-text-field
                class="mt-0"
                v-if="checkbox_other_org"
                v-model="other_org_descr"
                placeholder="название организации"
                label="название организации"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="6">
              <v-autocomplete
                v-model="org_position"
                :items="org_position_list"
                item-text="title"
                item-value="id"
                label="Должность"
                prepend-icon="mdi-badge-account"
                :error="org_position_error"
                >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" lg="6">
              <v-autocomplete
                v-model="academic_degree"
                :items="rang"
                item-text="title"
                item-value="id"
                :label='scienceDegreeLabel'
                prepend-icon="mdi-account"
                :error="academic_degree_error"
                >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row style="margin-top: -20px">
            <v-col class="pt-3" cols="12" lg="4">
              <v-checkbox
                class="mt-0"
                :color="$mainColor"
                v-model="checkbox_other_position"
                label="другая должность"
              ></v-checkbox>
            </v-col>
            <v-col class="pt-0" cols="12" lg="8">
              <v-text-field
                class="mt-0"
                v-if="checkbox_other_position"
                v-model="other_position_descr"
                placeholder="должность"
                label="должность"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="6">
              <div class="d-flex " style="height:40px; margin-top:10px;">
                <h1 class="switch__current-lang"  x-snall style=" padding-top: 19px;">Пол: Мужской</h1>
                <v-switch  style="color:white;" v-model="is_female" label="Женский"></v-switch>
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <v-menu
                v-model="birthDay"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedDateFormatted"
                    :label="birthDayLabel"
                    :hint="hint"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                  v-model="date" 
                  no-title 
                  @input="birthDay = false"
                  locale='ru-RU'
                  first-day-of-week=1
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <div>Данные входа в личный кабинет</div>
          <form autocomplete="off">
           
            <v-text-field
              v-model="email"
              label="E-mail"
              placeholder="ksrs@mail.ru"
              autocomplete="new-password"
              required
              :error-messages="emailValidate"
              :error="email_error"
            ></v-text-field>
            
            <v-card-subtitle
            style="padding: 0;">{{phoneLabel}}</v-card-subtitle>
            <v-text-field
              style="margin-top:0; padding-top:5px;"
              class="phone-number"
              v-model="phone"
               placeholder="918 333 33 33"
              required
              :error-messages="phoneValidate"
              :error="phone_error"
            ></v-text-field>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="password"
                  :append-icon="eyePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="eyePassword ? 'text' : 'password'"
                  name="input-10-1"
                  placeholder="qQ123ds!!"
                  autocomplete="off"
                  :label="passwordLabel"
                  :error-messages="passwordValidate"
                  :error="password_error"
                  @click:append="eyePassword = !eyePassword"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  :append-icon="eyePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="eyePassword ? 'text' : 'password'"
                  @click:append="eyePassword = !eyePassword"
                  name="input-10-2"
                  :label="repeatPasswordLabel"
                  placeholder="qQ123456!!"
                  v-model="confirmPassword"
                  class="input-group--focused"
                  :error-messages="password !== confirmPassword ? 'Пароли должны совпадать' : null"
                  :error="confirmPassword_error"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-checkbox
              :color="$mainColor"
              v-model="checkbox"
              :label="confirmRulesLabel"
              required
              
              :error-messages="checkboxCheck(checkbox)"
              :error="checkbox_error"
            ></v-checkbox>
            <v-btn
              :color="buttonColor"
              :loading="loaded"
              dark
              outlined
              class="mr-4"
              style="margin-top:10px;"
              @click="submit">{{buttonTextSubmit}}
            </v-btn>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            small
            target='_blank'
            @click="policy_dialog = true"
            color="#16336e">
            Политика конфиденциальности
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-main>
    <v-dialog v-model="policy_dialog" max-width="80%">
      <v-card  class="mx-auto content-personal" style="padding:30px; margin:30px; margin-top: 0px;" >
        <user-policy></user-policy>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="policy_dialog = false">закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import intlTelInput from 'intl-tel-input';
import { validationMixin } from 'vuelidate';
import moment from 'moment';
import { required, maxLength, email, minLength } from 'vuelidate/lib/validators/';
import { AUTH_URL, REFERENCES_URL } from '../../vars';
import { parserDate } from '../helpers/parserDate';
import { mapActions, mapGetters,mapMutations } from 'vuex';
import UserPolicy from '../components/Common/UserPolicy.vue';

export default {
  name: 'Registration',
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    select: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  components: {
    UserPolicy
  },
  data: () => ({
    loaded: false,
    resultRegistration: false,
    eyePassword: false,
    checkbox_error: false,
    name_error: false,
    lastName_error: false,
    middleName_error: false,
    phone_error: false,
    email_error: false,
    password_error: false,
    confirmPassword_error: false,
    valueOrganization_error: false,
    org_position_error: false,
    academic_degree_error: false,
    academic_rank_error: false,
    dialog: false,
    name: '',
    lastName: '',
    middleName: '',
    phone: '',
    email: '',
    info: '',
    select: null,
    password: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPassword: false,
    checkbox: true,
    org_position: '',
    academic_degree: '',
    academic_rank: '',
    valueOrganization: '',
    organizations: [],
    rang: [],
    org_position_list: [],
    date: new Date().toISOString().substr(0, 10),
    birthDay: false,
    is_female: false,
    head_info: '',
    buttonColor: '#4dbee1',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
    },
    disabled: true,
    codeCountry: '',
    checkbox_other_org: false,
    checkbox_other_position: false,
    other_org_descr: '',
    other_position_descr: '',
    policy_dialog: false,
  }),
  mounted() {
    // this.$i18n.locale = 'ru';

   /* document.querySelector('#input-72').setAttribute('autocomplete', 'off')
    document.querySelector('#input-78').setAttribute('autocomplete', 'off')
    document.querySelector('#input-82').setAttribute('autocomplete', 'off')*/

    let phoneInput = document.querySelector('.phone-number input');
    this.codeCountry = intlTelInput(phoneInput, {
      separateDialCode: true,
      preferredCountries: ['ru', 'ua', 'kz', 'by']
    })
  },
  async beforeMount() {
      const rang = await this.GET_ACADEMIC_DEGREE_REG();
      const organizations = await this.ORGANIZATION();
      this.organizations = await organizations.data;
      this.rang = await rang.data;
      const org_position_list = await this.GET_ORG_POSITION_LIST();
      this.org_position_list = await org_position_list.data;
  },
  validations: {
    lastName: {
      required,
      minLength: minLength(1)
    },
    name: {
      required,
      minLength: minLength(1)
    },
    middleName: {
      required,
      minLength: minLength(2)
    },
    phone: {
      required,
      validFormat: val => /\d{1,}/.test(val)
    },
    password: {
      required,
      validFormat: val => /[a-z]{1,}/.test(val) && val.length >= 8
    },
    academic_degree: {
      required,
      minLength: minLength(1)
    },
    org_position: {
      required,
      minLength: minLength(1)
    },
    email: {
      required,
      email
    },
  },
  computed: {
    lastNameValidate() {
      return this.$v.lastName.$invalid && this.$v.lastName.required ?
      '3 или более символов' : null
    },
    nameValidate() {
      return this.$v.name.$invalid && this.$v.name.required ?
      '3 или более символов' : null
    },
    middleNameValidate() {
      return this.$v.middleName.$invalid && this.$v.middleName.required ?
      '3 или более символов' : null
    },
    emailValidate() {
      return this.$v.email.$invalid && this.$v.email.required ?
      'Введите корректный E-mail' : null
    },
    phoneValidate() {
      return this.$v.phone.$invalid && this.$v.phone.required ?
      'Введите корректный номер телефона' : null
    },
    passwordValidate() {
      return this.$v.password.$invalid && this.$v.password.required ?
      '8 или более символов, включая как минимум 1 заглавную букву, 1 строчную букву и 1 цифру' : null
    },
    org_position_validate() {
      return this.$v.org_position.$invalid && this.$v.org_position.required ?
      'Введите значение' : null
    },
    academic_degree_validate() {
      return this.$v.academic_degree.$invalid && this.$v.academic_degree.required ?
      'Введите значение' : null
    },
    surNameLabel(){
      return 'Фамилия'
    },
    scienceOrganizationLabel(){
      return 'Научная организация'
    },
    confirmRulesLabel(){
      return "Нажимая кнопку 'Создать аккаунт', вы подтверждаете согласие на обработку персональных данных (ФЗ №152 «О персональных данных») и соглашаетесь с Политикой конфиденциальности"
    },
    nameLabel(){
      return 'Имя'
    },
    patronymicLabel(){
     return 'Отчество'
    },
    repeatPasswordLabel(){
      return 'Повторите пароль'
    },
    passwordLabel(){
      return 'Пароль'
    },
    rulesPassword(){
      return 'Пароль должен быть минимум 8 символов'
    },
    hint(){
      return 'мм/дд/гггг формат'
    },
    birthDayLabel(){
      return 'Дата рождения'
    },
    phoneLabel(){
      return 'Телефон'
    },
    scienceRankLabel(){
      return 'Научное звание'
    },
    scienceDegreeLabel(){
      return 'Научная степень'
    },
    buttonTextSubmit(){
      return 'Создать аккаунт'
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      if (!this.$v.select.required) errors.push('Item is required');
      return errors;
    },
    count() {
      return this.$store.state.count;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.maxLength) errors.push('очень длинное имя');
      if (!this.$v.name.required) errors.push('укажите Ваше имя');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push('неверный e-mail');
      if (!this.$v.email.required) errors.push('введите e-mail');
      return errors;
    },
  },
  methods: {
    ...mapActions([
      'REGISTRATION',
      'GET_ACADEMIC_DEGREE_REG',
      'ORGANIZATION',
      'GET_ORG_POSITION_LIST',
    ]),

    checkboxCheck(check) {
      if (check === null) return null;
      if (!check) return 'Обязательное поле';
      if (check) return null
    },
    redirectLogin(redirect) {
      redirect ? this.$router.push('/login') : null
    },
    get_params() {
      return {
        username: this.email,
        email: this.email,
        password: this.password,
        password_confirm: this.confirmPassword,
        first_name: this.name,
        last_name: this.lastName,
        individual: {
          middle_name: this.middleName,
          phone_number: this.codeCountry.getSelectedCountryData().dialCode + this.phone,
          academic_degree: this.academic_degree,
          is_female: this.is_female,
          org_position: this.org_position,
          organization: this.valueOrganization,
          birth_date: parserDate(this.computedDateFormatted, true),
        },
      };
    },
    async submit() {
      
      // this.dialog = true;

      // this.resultRegistration = true
//

      this.loaded = true;
      const userData = this.get_params();
      if(this.checkbox_other_org)
        userData['individual']['other_org_descr'] = this.other_org_descr
      if(this.checkbox_other_position)
        userData['individual']['other_position_descr'] = this.other_position_descr
      userData['site_type'] = 'rsini'

      console.log('registration', userData)

      this.org_position.length === 0 ? this.org_position_error = true : this.org_position_error = false
      this.academic_degree.length === 0 ? this.academic_degree_error = true : this.academic_degree_error = false
      this.valueOrganization.length === 0 ? this.valueOrganization_error = true : this.valueOrganization_error = false

      this.name.length === 0 ? this.name_error = true : this.name_error = false
      this.lastName.length === 0 ? this.lastName_error = true : this.lastName_error = false
      this.middleName.length === 0 ? this.middleName_error = true : this.middleName_error = false
      this.phone.length === 0 ? this.phone_error = true : this.phone_error = false
      this.email.length === 0 ? this.email_error = true : this.email_error = false
      this.password.length === 0 ? this.password_error = true : this.password_error = false
      this.confirmPassword.length === 0 ? this.confirmPassword_error = true : this.confirmPassword_error = false
      !this.checkbox && this.checkbox === null ? this.checkbox_error = true : this.checkbox_error = false
      
  
      if ((this.academic_degree.length === 0) ||
        (this.org_position.length === 0) ||
        (this.valueOrganization.length === 0) ||
        !this.checkbox ||
        this.$v.$invalid) {
          this.buttonColor = '#DC5959'
          this.loaded = false
          return
        };
      
      this.buttonColor = '#656565';
      this.REGISTRATION(userData)
      .then((res) => {
        if(res.data.errors !== undefined)
          this.show_reg_errors(res.data.errors)
        else{
          this.buttonText = 'Создать аккаунт';
          this.buttonColor = this.$mainColor;
        
          this.head_info = 'Личный кабинет создан';
          this.info = "На Вашу почту, указанную при регистрации, выслано электронное письмо. Письмо содержит ссылку для подтверждение аккаунта. Если письмо не пришло, пожалуйста, проверьте папку СПАМ."
          this.dialog = true;

          this.resultRegistration = true
          this.loaded = false
        }

      })
      .catch( (error) => {
        this.info += `Возможно, пользователь с таким Email уже существует, попробуйте восстановить пароль.`;
        this.loaded = false
        this.dialog = true;
        this.resultRegistration = false
        this.head_info = 'ошибка';
        this.buttonText = 'Создать аккаунт';
        this.buttonColor = this.$mainColor;

        // if (error.response.data.hasOwnProperty('username')) {
          //this.$messageHelper(`${error.response.data.username[0]}`, 'error', 3000)
          // this.info += `${error.response.data.username[0]}`;
        // }
        //  if (error.response.data.hasOwnProperty('password')) {
          //this.$messageHelper(`${error.response.data.password[0]}`, 'error', 3000)
          // this.info += `, ${error.response.data.password[0]}`;
        // }
        
      })

    },
    
    show_reg_errors(errors){
      Object.entries(errors).forEach(([key, val]) => {
        val.forEach(t => {
          this.info += t;
          this.info += ' ';
        })  
      });

      this.loaded = false
      this.dialog = true;
      this.resultRegistration = false
      this.head_info = 'ошибка';
      this.buttonText = 'Создать аккаунт';
      this.buttonColor = this.$mainColor;
    },

    clear() {
      this.$v.$reset();
      this.name = '';
      this.email = '';
      this.select = null;
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format('L');
    },
  },
  watch: {
    checkbox_other_org(val){
      if(val){
        this.valueOrganization = 134
      }
      else
        if(this.valueOrganization == 134)
          this.valueOrganization = ''
    },
    valueOrganization(val){
      if(val == '134')
        this.checkbox_other_org = true
      else
        this.checkbox_other_org = false
    },
    
    checkbox_other_position(val){
      if(val){
        this.org_position = 47
      }
      else
        if(this.org_position == 47)
          this.org_position = ''
    },
    org_position(val){
      if(val == '47')
        this.checkbox_other_position = true
      else
        this.checkbox_other_position = false
    },

    email(val){
      this.email = val.toLowerCase()
    },
  }
};
</script>
<style lang="scss">
.invalid {
  color: red;
  border: 1px solid red !important;
}
</style>